import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ThankYouShell from "../Common/ThankYouShell";
import s from "../Common/ThankYouShell.module.scss";

const VerifiedThankYou: React.FC = () => {
  const history = useNavigate();
  const [redirect, setRedirect] = useState<boolean>(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRedirect(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (redirect) {
      history("/login");
    }
  }, [redirect, history]);

  return (
    <ThankYouShell
      icon="mdi-check-circle-outline"
      title="Email Verified!"
      subtitle="Thank you for verifying your email address."
      actions={
        <div className={s.actions}>
          <Link to="/login" className={s.primaryBtn}>
            Continue to Login
          </Link>
        </div>
      }
    >
      <div className="text-center py-2">
        <h5 className="fw-bold mb-2" style={{ color: "#1E283D" }}>
          Account Verification Complete
        </h5>
        <p className="text-muted fs-6 mb-0">
          Please wait until your account is approved by an administrator. You will be automatically redirected to the login page shortly.
        </p>
      </div>
    </ThankYouShell>
  );
};

export default VerifiedThankYou;


